import React from 'react';
import './CardRowKeyVal.css';

export default ({ title, detail }) => (
  <div className="CardRowKeyVal">
    <div className="CardRowKeyVal-title">{title}</div>
    <div className="CardRowKeyVal-detail">{detail}</div>
  </div>
);
